import { mergeStyleSets } from '@uifabric/merge-styles';
import { Depths } from '@uifabric/fluent-theme';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: '100',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  loginBox: {
    width: pxToRem(416),
    backgroundColor: theme.palette.neutralWhite,
    paddingBottom: pxToRem(33),
    paddingTop: pxToRem(36),
    boxShadow: Depths.depth64,
  },
  buttons: {
    paddingTop: pxToRem(7),
    justifyContent: 'flex-end',
  },
});
